/** Tiny class-name composer. Filters out falsy/non-string args and joins with a space. */
export function cn(...args: Array<string | false | null | undefined | 0>): string {
  return args.filter((value): value is string => Boolean(value)).join(' ');
}
